import type { HelpCenterLinkProps } from "./help-center-link.type";

import { ExportOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { HELP_CENTER_URL } from "../help-center.constant";

import "./help-center-link.style.less";

export const HelpCenterLink = ({
  shortText,
  withIcon,
  onClick,
  children,
}: HelpCenterLinkProps) => {
  const { t } = useTranslation();
  const text = shortText
    ? t("global:helpCenter.shortLink")
    : t("global:helpCenter.link");

  return (
    <Link
      to={HELP_CENTER_URL}
      target="_blank"
      className="help-center-link"
      onClick={onClick}
    >
      {children ?? <span> {text}</span>}
      {withIcon && <ExportOutlined />}
    </Link>
  );
};
